<template>
  <footer>
    <div class="w-full bg-EXPONDO-primary text-EXPONDO-white">
      <div class="max-w-screen-2xl mx-auto px-4 py-9 lg:py-5 lg:px-10 flex flex-col gap-8 lg:gap-1">
        <div class="flex flex-col lg:flex-row gap-y-4">
          <div class="lg:w-1/2 flex flex-col justify-between">
            <div class="flex flex-col gap-10">
              <div class="pt-1">
                <img
                  class="w-40"
                  :src="EXPONDO_LOGO_LIGHT_DESKTOP_PATH"
                  alt="Expondo Logo"
                >
              </div>
              <LanguageSelector
                v-if="isMultiLanguage"
                :flag-path="languageSelectorProps.flagPath"
                :label="languageSelectorProps.label"
                :active-language-and-country="languageSelectorProps.activeLanguageAndCountry"
                :language-and-countries="languageSelectorProps.languageAndCountries"
                @change-language="onChangeLanguage"
              />
            </div>
          </div>
          <FooterLinkColumns
            class="lg:w-1/2"
            :should-show-webform="true"
            :footer-links="footerLinks"
            :trusted-payments-content="trustedPaymentsContent"
            @open-contact-form="openWebformModal"
          />
        </div>
        <div class="text-sm">
          {{ $t('we-deliver-anywhere') }}
        </div>
      </div>
      <Disclaimers />
    </div>
  </footer>
</template>

<script lang="ts">

import type { PropType } from 'vue';
import type { ComponentData } from '~~/types/cms/CmsComponentData';
import { EXPONDO_LOGO_LIGHT_DESKTOP_PATH } from '~~/constants/expondoLogoPath';
import { OPEN_HELP_CENTRE_WEBFORM } from '~~/constants/queryOptions';

export default defineComponent({
  name: 'AppFooter',

  props: {
    isMultiLanguage: {
      type: Boolean,
      default: false,
    },
    topLevelDomain: {
      type: String,
      required: true,
    },
    languageAndCountry: {
      type: String,
      required: true,
    },
    languageSelectorProps: {
      type: Object,
      default: () => ({}),
    },
    footerLinks: {
      type: Object,
      default: () => ({}),
    },
    trustedPaymentsContent: {
      type: Array as PropType<ComponentData[]>,
      default: () => [],
    },
  },

  setup() {

    const router = useRouter();
    const { openWebformModal } = useWebformModalStore();
    const { changeLanguage } = useLanguageSelector();

    const onChangeLanguage = (value: string): void => {

      changeLanguage(value);

    };

    onMounted(() => {

      const urlParams = typeof window === 'object' ? new URLSearchParams(window.location.search) : null;

      if (urlParams && urlParams.has(OPEN_HELP_CENTRE_WEBFORM)) {

        openWebformModal();
        urlParams.delete(OPEN_HELP_CENTRE_WEBFORM);
        router.replace({
          query: Object.fromEntries(urlParams.entries()),
        });

      }

    });

    return {
      EXPONDO_LOGO_LIGHT_DESKTOP_PATH,
      openWebformModal,
      onChangeLanguage,
    };

  },
});

</script>
